module.exports = __webpack_public_path__ + "img/apple.00466177.svg";